import React from 'react';
import { SheetBranding } from './types';
import { Building2 } from 'lucide-react';

interface PropertySheetBrandHeaderProps {
  branding: SheetBranding;
  className?: string;
}

export const PropertySheetBrandHeader: React.FC<PropertySheetBrandHeaderProps> = ({
  branding,
  className = '',
}) => {
  const isBroker = branding.profileType === 'broker';

  return (
    <div className={`flex items-center gap-2.5 flex-shrink-0 ${className}`}>
      <div className="text-right leading-normal max-w-[280px]">
        <div className="text-[14px] font-extrabold text-[#0a2540] tracking-normal leading-normal whitespace-nowrap">
          {branding.headerTitle}
        </div>
        {branding.headerSubtitleIsLink ? (
          <a
            href={branding.headerSubtitleHref || 'https://www.ciencuadras.com'}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[10px] text-sky-700 hover:underline font-medium block"
          >
            {branding.headerSubtitle}
          </a>
        ) : (
          <span className="text-[10px] text-slate-500 font-medium block">
            {branding.headerSubtitle}
          </span>
        )}
      </div>

      {isBroker ? (
        <div className="w-8 h-8 rounded-lg bg-[#0a2540] text-white flex items-center justify-center font-black text-xs shadow-xs flex-shrink-0">
          {branding.brokerInitials || 'BR'}
        </div>
      ) : (
        <div className="w-8 h-8 rounded-lg bg-[#0a2540] text-[#f59e0b] flex items-center justify-center shadow-xs flex-shrink-0">
          <Building2 className="w-4 h-4 text-[#f59e0b]" />
        </div>
      )}
    </div>
  );
};
